"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getContactsAssociationsOptions;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _ContactsSearchAPIQuery = require("crm_data/contacts/api/ContactsSearchAPIQuery");

var _AssociationOptionsDependencyHelpers = require("crm_data/associations/AssociationOptionsDependencyHelpers");

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

var _AssociationTypes = require("crm_data/associations/AssociationTypes");

var _immutable = require("immutable");

var _ContactsStore = _interopRequireDefault(require("crm_data/contacts/ContactsStore"));

function getAlreadyAssociatedContacts(values) {
  var contactIds = (0, _AssociationOptionsDependencyHelpers.getIdsFromOptions)(values, 'contactValues');
  var alreadyAssociatedContacts = contactIds ? _ContactsStore.default.get(contactIds) : (0, _immutable.List)();
  return (0, _AssociationOptionsDependencyHelpers.parseMatches)(alreadyAssociatedContacts);
}

function getContactsAssociationsOptions(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId,
      subject = _ref.subject,
      state = _ref.state,
      values = _ref.values;
  var debouncedSearchTextForElasticSearch = state.debouncedSearchTextForElasticSearch;
  var hasMinSearchText = (0, _AssociationOptionsDependencyHelpers.hasMinimumSearchText)(debouncedSearchTextForElasticSearch);
  var contactOptions = [];
  var alreadyAssociatedContacts = getAlreadyAssociatedContacts(values);

  if (objectType === _ObjectTypes.CONTACT) {
    if (subjectId !== 'null') {
      contactOptions = (0, _AssociationOptionsDependencyHelpers.parseMatches)((0, _immutable.List)([subject]));
    }
  }

  if (objectType === _ObjectTypes.COMPANY) {
    var numberOfContacts = Number((0, _ImmutableModel.getProperty)(subject, 'num_associated_contacts'));

    if (numberOfContacts > _EngagementAssociationsConstants.ASSOC_STORE_SEARCH_MAX && hasMinSearchText) {
      var contactsQuery = (0, _ContactsSearchAPIQuery.associatedWithCompany)(subjectId, _EngagementAssociationsConstants.MAX_OPTION_SIZE, debouncedSearchTextForElasticSearch);
      contactOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromElasticSearch)(subjectId, contactsQuery, _ObjectTypes.CONTACT);
    } else {
      contactOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, objectType + "_TO_CONTACT", _ObjectTypes.CONTACT);
    }
  } else if (objectType === _ObjectTypes.DEAL) {
    contactOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, _AssociationTypes.DEAL_TO_CONTACT, _ObjectTypes.CONTACT);
  } else if (objectType === _ObjectTypes.TICKET) {
    contactOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, _AssociationTypes.TICKET_TO_CONTACT, _ObjectTypes.CONTACT); // TODO: Use elastic search for getting contacts associated with ticket
  }

  var allContactOptions = (0, _immutable.List)(alreadyAssociatedContacts.concat(contactOptions || [])).reduce(function (map, option) {
    return map.set(option.id, option);
  }, (0, _immutable.Map)()).sortBy(function (match) {
    return match.text.toLowerCase();
  }).toArray();
  return allContactOptions;
}

module.exports = exports.default;